var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"imgModal","title":_vm.title,"size":"lg"},scopedSlots:_vm._u([{key:"modal-footer",fn:function(){return [_c('b-button',{staticClass:"btn"})]},proxy:true}])},[_c('div',{staticClass:"img_container"},[_c('img',{attrs:{"src":'/file/getImgFile/' + _vm.fileUrl,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }